module.exports = __webpack_public_path__ + "static/media/TMP_logo_large.23d7346e.jpg";